import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  public isLogged() {
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/homepage/homepage.component.ts